<app-header></app-header>
<main class="pagina">
  <div class="topo">
    <div class="topo-texto">
      <nav class="migalhas" aria-label="Você está em">
        <a routerLink="/home">Início</a> / <span>Relatórios</span> / <span class="atual">Ofertas e conversões</span>
      </nav>
      <h1>Ofertas e conversões</h1>
      <p>Venda de planos, upsell, cobranças e particulares por médico</p>
    </div>
    <nav class="seletor-relatorio" aria-label="Relatórios" data-teste="seletor-relatorio">
      <a *ngFor="let r of relatorios" [routerLink]="r.rota" routerLinkActive="ativo" #ativo="routerLinkActive"
         [attr.aria-current]="ativo.isActive ? 'page' : null">{{ r.curto }}</a>
    </nav>
  </div>

  <form class="filtros" (ngSubmit)="carregar()">
    <div class="segmentado" role="group" aria-label="Período rápido" data-teste="atalhos">
      <button *ngFor="let p of presets" type="button" [attr.data-preset]="p.valor" [attr.aria-pressed]="presetAtivo === p.valor"
              (click)="atalho(p.valor)" [disabled]="carregando">{{ p.rotulo }}</button>
    </div>
    <div class="campo">
      <span class="campo-rotulo">Período</span>
      <input type="date" name="de" aria-label="De" [(ngModel)]="de" [min]="minimo" [max]="hoje" required>
      <span class="campo-sep">a</span>
      <input type="date" name="ate" aria-label="Até" [(ngModel)]="ate" [min]="minimo" [max]="hoje" required>
    </div>
    <div *ngIf="mostraSeletor" id="unidade-relatorio" class="seletor-unidade">
      <app-lista-selecao [itens]="itensUnidade" [valor]="unidade" [comBusca]="itensUnidade.length > 6"
                         rotuloAcessivel="Unidade" (escolher)="unidade = $event"><span class="campo-rotulo">Unidade</span></app-lista-selecao>
    </div>
    <div *ngIf="!mostraSeletor" class="campo">
      <span class="campo-rotulo">Unidade</span>
      <span class="valor-fixo">{{ nomeUnidadeLogada || unidadeLogada }}</span>
    </div>
    <span class="espaco"></span>
    <span *ngIf="erroExportar" class="erro-texto">{{ erroExportar }}</span>
    <button type="button" class="btn-agua" (click)="exportar()" [disabled]="exportando || !aplicado">{{ exportando ? 'Exportando...' : 'Exportar Excel' }}</button>
    <button type="submit" class="btn-acao" [disabled]="carregando">{{ carregando ? 'Carregando...' : 'Atualizar' }}</button>
  </form>

  <div *ngIf="erro" class="aviso-erro">
    <span>{{ erro }}</span>
    <button type="button" class="btn-borda" data-teste="tentar-de-novo" (click)="carregar()">Tentar de novo</button>
  </div>

  <div *ngIf="carregando && !resumo" class="secao vazio" data-teste="carregando">
    <p class="vazio-titulo">Carregando o relatório…</p>
    <p class="nota">Períodos longos ou "Todas" as unidades podem levar alguns segundos.</p>
  </div>

  <div *ngIf="resumo && semDados" class="secao vazio" data-teste="sem-dados">
    <span class="selo selo-neutro">Sem movimento</span>
    <p class="vazio-titulo">Nenhum atendimento da Fila v3 neste período</p>
    <p class="nota">O relatório conta só atendimentos abertos pela Fila v3 e ofertas registradas depois da implantação.
      Tente outro período{{ admin ? ' ou outra unidade' : '' }}.</p>
  </div>

  <ng-template #controle let-q let-titulo="titulo">
    <div class="segmentado pequeno vistas" role="group" [attr.aria-label]="'Ver ' + titulo + ' como'">
      <button type="button" [attr.data-vista]="q + ':grafico'" [attr.aria-pressed]="vistaDe(q) === 'grafico'" (click)="mudarVista(q, 'grafico')">Gráfico</button>
      <button type="button" [attr.data-vista]="q + ':tabela'" [attr.aria-pressed]="vistaDe(q) === 'tabela'" (click)="mudarVista(q, 'tabela')">Tabela</button>
    </div>
  </ng-template>

  <ng-template #linhaTotal let-pausa let-fechou="fechou">
    <tr *ngIf="resumo" class="total" data-teste="linha-total">
      <td>Total</td><td>{{ resumo.conversao.particulares }}</td><td>{{ resumo.conversao.viramOferta }}</td><td>{{ resumo.conversao.recusaram }}</td>
      <td>{{ resumo.conversao.naFila }}</td><td>{{ resumo.conversao.depois }}</td>
      <td *ngIf="pausa">{{ resumo.conversao.naPausa ?? 0 }}</td><td *ngIf="fechou">{{ resumo.conversao.fechouNaPausa ?? 0 }}</td>
      <td>{{ pctPronto(resumo.conversao.percentual) }}</td>
    </tr>
  </ng-template>

  <ng-template #paginacao let-q>
    <div *ngIf="paginasDe(q) > 1" class="paginacao" [attr.data-paginacao]="q">
      <button type="button" class="btn-borda" data-teste="anterior" [disabled]="paginaAtual(q) <= 1" (click)="irPara(q, paginaAtual(q) - 1)">Anterior</button>
      <span>Página {{ paginaAtual(q) }} de {{ paginasDe(q) }}</span>
      <button type="button" class="btn-borda" data-teste="proxima" [disabled]="paginaAtual(q) >= paginasDe(q)" (click)="irPara(q, paginaAtual(q) + 1)">Próxima</button>
    </div>
  </ng-template>

  <ng-template #info let-p>
    <button type="button" class="info" [attr.aria-label]="'O que é ' + p.titulo"
            [attr.aria-expanded]="explicacao === p.chave" [attr.aria-controls]="'def-' + p.chave"
            (click)="$event.stopPropagation(); alternarExplicacao(p.chave)">
      <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
        <circle cx="8" cy="8" r="6.6" fill="none" stroke="currentColor" stroke-width="1.3"/>
        <circle cx="8" cy="5" r="0.9" fill="currentColor"/>
        <path d="M8 7.4v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </button>
    <div *ngIf="explicacao === p.chave" class="definicao" role="note" [id]="'def-' + p.chave"
         (click)="$event.stopPropagation()">{{ p.definicao }}</div>
  </ng-template>

  <ng-template #particulares let-q let-titulo="titulo" let-sub="sub" let-ancora="ancora">
    <section [id]="ancora" class="secao coluna-lista" [attr.data-quadro]="q">
      <header class="secao-cabeca compacta">
        <div>
          <h2>{{ titulo }}</h2>
          <p class="secao-sub">{{ sub }}</p>
        </div>
        <div class="ordenar">
          Ordenar
          <div class="segmentado pequeno" role="group" [attr.aria-label]="'Ordenar ' + titulo">
            <button *ngFor="let o of ordens" type="button" [attr.data-ordem]="q + ':' + o.valor" [attr.aria-pressed]="ordemDe(q) === o.valor"
                    (click)="ordenarPor(q, o.valor)">{{ o.rotulo }}</button>
          </div>
        </div>
      </header>
      <ng-container *ngIf="resumoDe(q) as r">
        <div class="resumo-lista" data-teste="resumo-lista" [class.apagado]="!r.atendimentos">
          <b>{{ r.taxa }}</b>
          <span>{{ r.particulares }} {{ r.particulares === 1 ? 'particular' : 'particulares' }} em {{ r.atendimentos }} atendimentos<ng-container *ngIf="q === 'especialidade' && r.destaque"> · {{ r.destaque.nome }} concentra {{ r.destaque.parte }}% dos particulares</ng-container></span>
          <span *ngIf="!r.atendimentos" class="selo selo-neutro">Sem movimento</span>
        </div>
      </ng-container>
      <div class="linhas">
        <button *ngFor="let v of linhasVisao(q); trackBy: porIndice" type="button" class="linha-part clicavel" [attr.data-linha]="v.linha.chave"
                (click)="abrirParticulares(q, v.linha.chave)">
          <span class="linha-topo">
            <span class="linha-nome">{{ v.linha.nome }}<small *ngIf="q === 'medico' && v.linha.especialidade" class="linha-esp">{{ v.linha.especialidade }}</small></span>
            <span class="linha-base">{{ v.linha.particulares }} de {{ v.linha.atendimentos }}<ng-container *ngIf="v.linha.convertidos"> · {{ v.linha.convertidos }} {{ v.linha.convertidos === 1 ? 'assinou' : 'assinaram' }}</ng-container></span>
            <span class="linha-taxa" [class.zero]="!v.linha.particulares">{{ v.taxa }}</span>
          </span>
          <span class="volume"><span class="volume-total" [style.width.%]="v.volume"><span class="volume-parte" [style.width.%]="v.parte"></span></span></span>
        </button>
      </div>
      <div class="legenda-lista">
        <span class="legenda-itens">
          <span><i class="quadro-legenda verde"></i>Particular</span>
          <span><i class="quadro-legenda agua"></i>Demais atendimentos</span>
        </span>
        <span>Comprimento da barra = volume de atendimentos</span>
      </div>
      <ng-container *ngTemplateOutlet="paginacao; context: { $implicit: q }"></ng-container>
    </section>
  </ng-template>

  <ng-container *ngIf="resumo && !semDados">
    <nav class="ancoras" aria-label="Seções do relatório" data-teste="ancoras">
      <button *ngFor="let s of secoes; trackBy: porId" type="button" [attr.data-ancora]="s.id" [class.ativa]="secaoAtiva === s.id"
              [attr.aria-current]="secaoAtiva === s.id ? 'true' : null" (click)="irParaSecao(s.id)">{{ s.rotulo }}</button>
    </nav>

    <div class="secoes" [class.atualizando]="carregando">
      <!-- 1. Venda de plano -->
      <section id="s-plano" class="secao" data-quadro="venda">
        <header class="secao-cabeca com-linha">
          <div class="titulo-linha">
            <h2>Venda de plano para particulares</h2>
            <span class="pilula-periodo" data-teste="periodo">{{ periodoCurto }}</span>
          </div>
          <button type="button" class="como-ler-botao" [attr.aria-expanded]="ajuda" aria-controls="como-ler" data-teste="como-ler-botao"
                  (click)="ajuda = !ajuda"><span class="interrogacao" aria-hidden="true">?</span>Como ler este relatório</button>
        </header>
        <div *ngIf="ajuda" id="como-ler" class="como-ler" data-teste="como-ler">
          <p *ngFor="let g of glossario"><strong>{{ g.termo }}</strong> — {{ g.texto }}</p>
        </div>

        <div class="visao">
          <div class="conversao" [class.apagado]="!resumo.conversao.particulares">
            <span class="eyebrow verde">Conversão da oferta</span>
            <div class="conversao-numero">
              <b class="taxa-grande" data-teste="conversao-total">{{ resumo.conversao.particulares ? pctPronto(resumo.conversao.percentual) : '—' }}</b>
              <p data-teste="resultado"><strong>{{ assinantes }} de {{ resumo.conversao.particulares }}</strong> particulares <br>viraram assinantes</p>
            </div>
            <div class="onde">
              <span class="onde-titulo">Onde compraram</span>
              <div class="onde-barra" aria-hidden="true">
                <span *ngIf="resumo.conversao.naFila" class="seg-atend" [style.flex]="resumo.conversao.naFila"></span>
                <span *ngIf="resumo.conversao.naPausa" class="seg-pausa" [style.flex]="resumo.conversao.naPausa"></span>
                <span *ngIf="resumo.conversao.depois" class="seg-depois" [style.flex]="resumo.conversao.depois"></span>
              </div>
              <div class="onde-legenda">
                <button *ngFor="let p of passosCompra; trackBy: porChave" type="button" class="legenda-item clicavel" [attr.data-passo]="p.chave"
                        [class.zero]="!p.valor" (click)="abrirPasso(p)">
                  <span class="legenda-rotulo"><i [class]="'marcador m-' + p.chave"></i>{{ p.titulo }}</span>
                  <b class="passo-num">{{ p.valor }}</b>
                  <span class="legenda-sub">{{ p.sub }}</span>
                </button>
              </div>
            </div>
          </div>

          <div class="lado">
            <ol class="jornada" data-teste="jornada">
              <ng-container *ngFor="let p of passosTopo; let ultimo = last; trackBy: porChave">
                <li class="passo" [attr.data-passo]="p.chave">
                  <button type="button" class="passo-abrir clicavel" (click)="abrirPasso(p)">
                    <span class="passo-titulo">{{ p.titulo }}</span>
                    <b class="passo-num">{{ p.valor }}</b>
                    <span *ngIf="p.chave === 'particulares'" class="passo-sub">{{ p.sub }}</span>
                    <span *ngIf="p.chave === 'viram'" class="passo-sub">
                      <strong class="verde">{{ pct(resumo.conversao.viramOferta, resumo.conversao.particulares) }}</strong>
                      {{ naoViramTotal ? 'dos particulares · ' + naoViramTotal + ' não viram' : '· ninguém ficou sem ver' }}
                    </span>
                  </button>
                  <ng-container *ngTemplateOutlet="info; context: { $implicit: p }"></ng-container>
                </li>
                <li *ngIf="!ultimo" class="seta" aria-hidden="true">→</li>
              </ng-container>
            </ol>

            <div class="pagamento" data-teste="pagamento">
              <span class="icone-rs" aria-hidden="true">R$</span>
              <div class="pagamento-texto">
                <span class="rotulo-12">Pagamento das compras pela Fila</span>
                <p *ngIf="comprasFila; else semCompras">
                  <button type="button" class="link" (click)="abrirLista('funil', 'contratada', 'Planos vendidos (pagos)')">{{ vendidos }} de {{ comprasFila }}</button>
                  {{ vendidos === 1 ? 'já foi paga' : 'já foram pagas' }}
                </p>
                <ng-template #semCompras><p class="apagado-tx">Nenhuma compra pela Fila no período</p></ng-template>
              </div>
              <span class="selo selo-bom" *ngIf="comprasFila">{{ pct(vendidos, comprasFila) }}</span>
            </div>

            <div *ngIf="resumo.conversao.emAtraso || resumo.conversao.clienteAtivo" class="fora-conta" data-teste="fora-da-conta">
              <span class="eyebrow">Fora da conta · já são clientes CartãoSiM</span>
              <div class="fora-itens">
                <ng-container *ngIf="resumo.conversao.emAtraso">
                  <span><button type="button" class="link forte" (click)="abrirLista('conversao', 'em_atraso', 'Clientes em atraso atendidos no particular')">{{ resumo.conversao.emAtraso }}</button>
                    em atraso <span class="tx-3">— recebem regularização</span></span>
                  <span><button type="button" class="link forte" (click)="abrirLista('conversao', 'em_atraso_sem', 'Em atraso sem regularização gerada')">{{ emAtrasoSemRegularizacao }}</button>
                    sem regularização gerada</span>
                </ng-container>
                <span *ngIf="resumo.conversao.clienteAtivo"><button type="button" class="link forte" (click)="abrirLista('conversao', 'cliente_ativo', 'Assinantes ativos atendidos no particular')">{{ resumo.conversao.clienteAtivo }}</button>
                  assinantes em dia <span class="tx-3">atendidos no particular</span></span>
              </div>
            </div>
          </div>
        </div>

        <p *ngIf="!resumo.conversao.particulares" class="nota recuo" data-teste="sem-particulares">
          Nenhum particular atendido pela Fila v3 no período. Só contam atendimentos abertos na v3 a partir de 16/10/2026, às 17h,
          quando ela passou a ser identificada; as ofertas e vendas abaixo já aparecem desde o início do registro.
        </p>

        <div class="recuo-baixo">
          <div class="interno" data-teste="etapas">
            <div class="interno-cabeca">
              <div>
                <h3>Etapas depois da oferta</h3>
                <p class="secao-sub">Percentual sobre os {{ resumo.conversao.viramOferta }} que viram a oferta</p>
              </div>
              <div class="controles">
                <div *ngIf="vistaDe('venda') === 'grafico'" class="segmentado pequeno" role="group" aria-label="Escala das etapas">
                  <button type="button" data-escala="ampliada" [attr.aria-pressed]="escalaEtapas === 'ampliada'" (click)="escalaEtapas = 'ampliada'">Ampliada</button>
                  <button type="button" data-escala="real" [attr.aria-pressed]="escalaEtapas === 'real'" (click)="escalaEtapas = 'real'">Real</button>
                </div>
                <ng-container *ngTemplateOutlet="controle; context: { $implicit: 'venda', titulo: 'etapas depois da oferta' }"></ng-container>
              </div>
            </div>
            <div *ngIf="vistaDe('venda') === 'grafico'" class="etapas">
              <button *ngFor="let e of etapas; let i = index; trackBy: porChave" type="button" class="etapa clicavel" [attr.data-etapa]="e.chave" (click)="abrirEtapa(e.chave)">
                <span class="bolinha" [class.primeira]="i === 0">{{ i + 1 }}</span>
                <span class="etapa-nome">{{ e.rotulo }}</span>
                <span class="trilho">
                  <span class="preenchido" [style.width.%]="e.largura"
                        [class.referencia]="i === 0 && escalaEtapas === 'ampliada'" [class.base-real]="i === 0 && escalaEtapas === 'real'"
                        [class.recusa]="e.chave === 'recusaram'"></span>
                </span>
                <span class="etapa-valor"><b>{{ e.total }}</b><small>{{ i === 0 ? 'base' : e.deQuemViu }}</small></span>
              </button>
              <p *ngIf="escalaEtapas === 'ampliada'" class="nota-rodape">Escala ampliada: barras proporcionais à maior etapa ({{ maiorEtapa }}). “Viram a oferta” fica como referência.</p>
            </div>
            <table *ngIf="vistaDe('venda') === 'tabela'" class="tabela fixa">
              <thead><tr><th>Etapa</th><th>Pacientes</th><th>% de quem viu</th></tr></thead>
              <tbody><tr *ngFor="let e of etapas" class="clicavel" (click)="abrirEtapa(e.chave)">
                <td>{{ e.rotulo }}</td><td>{{ e.total }}</td><td>{{ e.deQuemViu }}</td>
              </tr></tbody>
            </table>
          </div>

          <div id="s-nao-viram" class="interno nao-viram" data-teste="por-que-nao-viram">
            <button type="button" class="interno-cabeca recolhivel" [attr.aria-expanded]="naoViramAberto" data-teste="nao-viram-toggle"
                    (click)="naoViramAberto = !naoViramAberto">
              <div>
                <h3>Por que nem todo particular vê a oferta</h3>
                <p class="secao-sub">{{ naoViramTotal ? naoViramTotal + (naoViramTotal === 1 ? ' particular não viu' : ' particulares não viram') + ' a oferta no período' : 'Todos os particulares atendidos viram a oferta' }}</p>
              </div>
              <span class="flex items-center gap-2">
                <span *ngIf="!naoViramTotal" class="selo selo-neutro">Sem movimento</span>
                <svg class="seta-recolher" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 7.5l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </span>
            </button>
            <div *ngIf="naoViramAberto" class="nao-viram-corpo">
              <div *ngIf="naoViramComTotal.length" class="motivos" data-teste="nao-viram">
                <button *ngFor="let m of naoViramComTotal" type="button" class="motivo clicavel"
                        (click)="abrirLista('conversao', 'nao_viram:' + m.chave, m.rotulo)">{{ m.rotulo }} <b>{{ m.total }}</b></button>
              </div>
              <p class="nota">A diferença entre “Particulares atendidos” e “Viram a oferta” são particulares que ninguém abordou. A oferta só aparece na etapa de pagamento do atendimento, e fica de fora quando:</p>
              <ul class="lista-motivos">
                <li>o operador do guichê não tem cadastro de vendedor no CartãoSiM;</li>
                <li>o paciente não tem CPF cadastrado;</li>
                <li>o atendimento não passou pela etapa de pagamento (pagamento pulado ou atendimento aberto por outro caminho);</li>
                <li>o CartãoSiM não devolveu planos para a unidade.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <!-- 2. Venda por plano -->
      <section id="s-planos" class="secao" data-quadro="planos">
        <header class="secao-cabeca com-linha">
          <div>
            <h2>Venda por plano</h2>
            <p class="secao-sub legenda">Taxa de compra = vendidos com oferta registrada ÷ ofertados</p>
          </div>
          <div class="controles">
            <span *ngIf="!planos.length" class="selo selo-neutro">Sem movimento</span>
            <ng-container *ngTemplateOutlet="controle; context: { $implicit: 'planos', titulo: 'venda por plano' }"></ng-container>
          </div>
        </header>
        <div *ngIf="vistaDe('planos') === 'grafico'" class="planos">
          <div *ngFor="let v of planosVisao" class="plano" [attr.data-plano]="v.plano.familia" [class.recusado]="v.selo?.tipo === 'alerta'">
            <div class="plano-topo">
              <span class="plano-nome">{{ v.nome }}</span>
              <span *ngIf="v.selo" class="selo" [class.selo-alerta]="v.selo.tipo === 'alerta'" [class.selo-bom]="v.selo.tipo === 'bom'" [class.selo-neutro]="v.selo.tipo === 'neutro'"
                    [attr.data-teste]="v.selo.tipo === 'alerta' ? 'mais-recusado' : v.selo.tipo === 'bom' ? 'mais-aceito' : 'selo-plano'">{{ v.selo.texto }}</span>
            </div>
            <div class="plano-taxa"><b [class.sem]="!v.plano.ofertado">{{ v.taxa }}</b><span>taxa de compra</span></div>
            <span class="barra-fina"><span [style.width.%]="v.largura"></span></span>
            <div class="plano-numeros">
              <span><b>{{ v.plano.vendido }}</b> vendidos</span>
              <span><b>{{ v.plano.ofertado }}</b> ofertados</span>
            </div>
            <span *ngIf="v.plano.vendidoSemOferta" class="nota-linha">+{{ v.plano.vendidoSemOferta }} sem oferta registrada</span>
          </div>
          <p *ngIf="!planos.length" class="nota">Nenhum plano ofertado no período.</p>
        </div>
        <div *ngIf="vistaDe('planos') === 'tabela'" class="recuo">
          <table class="tabela fixa">
            <thead><tr><th>Plano</th><th>Ofertado</th><th>Recusado</th><th>Termo enviado</th><th>Foi para pagamento</th><th>Vendido</th><th>Vendido sem oferta registrada</th><th>Taxa de compra</th></tr></thead>
            <tbody><tr *ngFor="let p of planos">
              <td>{{ rotuloPlano(p.familia) }}
                <span *ngIf="p.familia === maisAceito" class="selo selo-bom">mais aceito</span>
                <span *ngIf="p.familia === maisRecusado" class="selo selo-alerta">mais recusado</span></td>
              <td>{{ p.ofertado }}</td><td>{{ p.recusado }}</td><td>{{ p.termo }}</td><td>{{ p.pagamento }}</td><td>{{ p.vendido }}</td>
              <td data-teste="sem-oferta">{{ p.vendidoSemOferta ?? 0 }}</td>
              <td>{{ p.ofertado ? pctPronto(p.aceite) : '—' }}</td>
            </tr></tbody>
          </table>
        </div>
        <p *ngIf="totalSemOferta" class="nota recuo-nota" data-teste="total-sem-oferta">
          {{ totalSemOferta }} {{ totalSemOferta === 1 ? 'venda' : 'vendas' }} da Fila no período sem oferta registrada para o paciente
          (o registro das ofertas começou em 16/10/2026). Elas contam em “Planos vendidos”, mas ficam fora da taxa de compra.
        </p>
      </section>

      <!-- 3. Unidade e operador -->
      <section id="s-operador" class="secao" data-quadro="operador">
        <header class="secao-cabeca alto">
          <div class="cabeca-texto">
            <h2>Conversão por unidade e operador</h2>
            <p class="secao-sub">Cada quadrado é um particular atendido; verde é quem assinou</p>
            <div class="controles">
              <ng-container *ngTemplateOutlet="controle; context: { $implicit: 'operador', titulo: 'conversão por unidade e operador' }"></ng-container>
            </div>
          </div>
          <div class="etiquetas">
            <button *ngFor="let u of unidadesVisao" type="button" class="etiqueta-unidade" [attr.data-unidade]="u.id" (click)="abrirConversao('unidade:' + u.id)">
              <span class="etiqueta-nome"><span class="eyebrow">Unidade</span><b>{{ u.nome }}</b></span>
              <span class="etiqueta-div" aria-hidden="true"></span>
              <b class="etiqueta-taxa">{{ u.taxa }}</b>
              <span class="etiqueta-det">{{ u.assinaram }} de {{ u.particulares }} particulares assinaram</span>
            </button>
          </div>
        </header>

        <div *ngIf="!resumo.conversaoPorOperador.length && !resumo.conversaoPorUnidade?.length" class="recuo vazio-linha">
          <span class="selo selo-neutro">Sem movimento</span>
          <span class="nota">Nenhum particular atendido por operador no período.</span>
        </div>

        <ng-container *ngIf="vistaDe('operador') === 'grafico'">
          <div *ngIf="resumo.conversaoPorOperador.length" class="operadores">
            <span class="eyebrow verde">Venderam no período · {{ operadores.venderam.length }}</span>
            <button *ngFor="let o of operadores.venderam; trackBy: porNome" type="button" class="operador-vendeu clicavel" [attr.data-operador]="o.nome"
                    (click)="abrirConversao('operador:' + o.nome)">
              <span class="op-nome"><span class="avatar">{{ o.iniciais }}</span><b>{{ o.nome }}</b></span>
              <span class="waffle" [attr.aria-label]="o.parte + ' de ' + o.base + ' particulares assinaram'">
                <i *ngFor="let q of o.waffle.quadros; trackBy: porIndice" [class.sim]="q"></i>
                <small *ngIf="o.waffle.resto" class="waffle-resto">+{{ o.waffle.resto }}</small>
              </span>
              <span class="op-taxa"><b>{{ o.taxa }}</b><small>{{ o.parte }} de {{ o.base }}</small></span>
            </button>
            <p *ngIf="!operadores.venderam.length" class="nota">Nenhum operador vendeu no período.</p>

            <div class="sem-venda-cabeca">
              <span class="eyebrow">Ainda sem venda · {{ operadores.semVenda.length }}</span>
              <span class="nota-11">{{ operadores.atendidosSemVenda }} particulares atendidos sem assinatura</span>
            </div>
            <div class="sem-venda">
              <button *ngFor="let o of operadores.semVenda; trackBy: porNome" type="button" class="operador-sem clicavel" [attr.data-operador]="o.nome"
                      (click)="abrirConversao('operador:' + o.nome)">
                <span class="op-nome"><span class="avatar claro">{{ o.iniciais }}</span><b>{{ o.nome }}</b><small>0 de {{ o.base }}</small></span>
                <span class="waffle pequeno" [attr.aria-label]="'0 de ' + o.base + ' particulares assinaram'">
                  <i *ngFor="let q of o.waffle.quadros; trackBy: porIndice"></i>
                  <small *ngIf="o.waffle.resto" class="waffle-resto">+{{ o.waffle.resto }}</small>
                </span>
              </button>
            </div>
          </div>
        </ng-container>

        <div *ngIf="vistaDe('operador') === 'tabela'" class="recuo tabelas">
          <ng-container *ngIf="resumo.conversaoPorUnidade?.length">
            <h3 class="subtitulo">Por unidade</h3>
            <table class="tabela fixa" data-teste="tabela-unidade">
              <thead><tr><th>Unidade</th><th>Particulares atendidos</th><th>Viram a oferta</th><th>Recusaram algum plano</th><th>Compraram no atendimento</th><th>Compraram depois (7 dias)</th><th>Na pausa</th><th>Conversão total</th></tr></thead>
              <tbody><tr *ngFor="let u of resumo.conversaoPorUnidade" class="clicavel" (click)="abrirConversao('unidade:' + u.unidade)">
                <td>{{ nomeUnidade(u.unidade) }}</td><td>{{ u.particulares }}</td><td>{{ u.viramOferta }}</td><td>{{ u.recusaram }}</td><td>{{ u.naFila }}</td><td>{{ u.depois }}</td><td>{{ u.naPausa ?? 0 }}</td><td>{{ pctPronto(u.percentual) }}</td>
              </tr></tbody>
              <tfoot><ng-container *ngTemplateOutlet="linhaTotal; context: { $implicit: true }"></ng-container></tfoot>
            </table>
          </ng-container>
          <ng-container *ngIf="resumo.conversaoPorOperador.length">
            <h3 class="subtitulo">Por operador</h3>
            <table class="tabela fixa" data-teste="tabela-operador">
              <thead><tr><th>Operador</th><th>Particulares atendidos</th><th>Viram a oferta</th><th>Recusaram algum plano</th><th>Compraram no atendimento</th><th>Compraram depois (7 dias)</th><th>Na pausa</th><th>Fecharam na pausa</th><th>Conversão total</th></tr></thead>
              <tbody><tr *ngFor="let c of resumo.conversaoPorOperador" class="clicavel" (click)="abrirConversao('operador:' + c.operador)">
                <td>{{ c.operador }}</td><td>{{ c.particulares }}</td><td>{{ c.viramOferta }}</td><td>{{ c.recusaram }}</td><td>{{ c.naFila }}</td><td>{{ c.depois }}</td><td>{{ c.naPausa ?? 0 }}</td><td>{{ c.fechouNaPausa ?? 0 }}</td><td>{{ pctPronto(c.percentual) }}</td>
              </tr></tbody>
              <tfoot><ng-container *ngTemplateOutlet="linhaTotal; context: { $implicit: true, fechou: true }"></ng-container></tfoot>
            </table>
          </ng-container>
        </div>
        <p class="rodape-secao">Compra por link de checkout aparece como “depois”: o CartãoSiM não marca o canal.</p>
      </section>

      <!-- 4. Upsell + cobrança -->
      <section id="s-upsell" class="secao lado-a-lado">
        <div class="coluna" data-quadro="upsell">
          <div class="coluna-cabeca">
            <div><h2>Upsell</h2><p class="secao-sub">Melhoria de plano para quem já é cliente</p></div>
            <span *ngIf="upsellParado" class="selo selo-neutro">Sem movimento</span>
          </div>
          <div class="fluxo" [class.parado]="upsellParado">
            <button type="button" class="kpi clicavel" (click)="abrirLista('regularizacao', 'migracoes', 'Melhorias de plano iniciadas')"><b>{{ upsell.iniciadas }}</b><span>Iniciadas</span></button>
            <span class="seta" aria-hidden="true">→</span>
            <button type="button" class="kpi clicavel" (click)="abrirLista('regularizacao', 'migracoes_pagas', 'Melhorias de plano pagas')"><b>{{ upsell.pagas }}</b><span>Pagas</span></button>
            <span class="seta" aria-hidden="true">→</span>
            <div class="kpi"><b>{{ upsell.iniciadas ? pctPronto(upsell.taxa) : '—' }}</b><span>Concluído</span></div>
          </div>
          <p *ngIf="upsell.porPlanoDestino.length" class="destinos" data-teste="upsell-destinos">
            <span class="tx-3">Por plano de destino:</span>
            <span *ngFor="let i of upsell.porPlanoDestino; let ultimo = last">{{ i.rotulo }} <b>{{ i.total }}</b>{{ ultimo ? '' : ' ·' }}</span>
          </p>
        </div>
        <div class="coluna" data-quadro="cobranca">
          <div class="coluna-cabeca">
            <div><h2>Cobrança de inadimplentes</h2><p class="secao-sub">Regularização de clientes CartãoSiM em atraso</p></div>
            <span *ngIf="cobrancaParada" class="selo selo-neutro">Sem movimento</span>
          </div>
          <div class="fluxo" [class.parado]="cobrancaParada">
            <button type="button" class="kpi clicavel" (click)="abrirCobranca('regularizacoes')"><b>{{ cobranca.geradas }}</b><span>Geradas</span></button>
            <span class="seta" aria-hidden="true">→</span>
            <button type="button" class="kpi clicavel" (click)="abrirCobranca('regularizacoes_pagas')"><b>{{ cobranca.pagas }}</b><span>Pagas · {{ cobranca.geradas ? pctPronto(cobranca.taxa) : '—' }}</span></button>
            <span class="seta" aria-hidden="true">→</span>
            <div class="kpi largo"><b class="valor">{{ brl(cobranca.valorRecuperado) }}</b><span>Recuperado</span></div>
          </div>
          <button *ngIf="emAtrasoSemRegularizacao > 0" type="button" class="alerta clicavel" data-teste="alerta-cobranca"
                  (click)="abrirLista('conversao', 'em_atraso_sem', 'Em atraso sem regularização gerada')">
            <i aria-hidden="true"></i>
            <span><strong>{{ emAtrasoSemRegularizacao }} {{ emAtrasoSemRegularizacao === 1 ? 'cliente em atraso' : 'clientes em atraso' }}</strong>
              {{ emAtrasoSemRegularizacao === 1 ? 'passou' : 'passaram' }} pela Fila sem regularização gerada</span>
          </button>
        </div>
      </section>

      <!-- Venda cartão fora do atendimento -->
      <section *ngIf="resumo.vendaCartao?.abordagens" id="s-venda-cartao" class="secao" data-quadro="venda-cartao">
        <header class="secao-cabeca com-linha">
          <div>
            <h2>Venda cartão fora do atendimento</h2>
            <p class="secao-sub">Abordagens feitas na pausa Venda Cartão</p>
          </div>
        </header>
        <div class="recuo">
          <div class="fluxo">
            <button type="button" class="kpi clicavel" (click)="abrirVendaCartao('abordagens', 'Abordagens de venda cartão')"><b>{{ resumo.vendaCartao!.abordagens }}</b><span>Abordagens</span></button>
            <span class="seta" aria-hidden="true">→</span>
            <button type="button" class="kpi clicavel" (click)="abrirVendaCartao('recusas', 'Recusas de venda cartão')"><b>{{ resumo.vendaCartao!.recusas }}</b><span>Recusas</span></button>
            <button type="button" class="kpi clicavel" (click)="abrirVendaCartao('andamento', 'Venda cartão em andamento')"><b>{{ resumo.vendaCartao!.emAndamento }}</b><span>Em andamento</span></button>
            <button type="button" class="kpi clicavel" (click)="abrirVendaCartao('contratadas', 'Venda cartão contratada')"><b>{{ resumo.vendaCartao!.contratadas }}</b><span>Contratadas</span></button>
            <span class="seta" aria-hidden="true">→</span>
            <div class="kpi destaque"><b>{{ pctPronto(resumo.vendaCartao!.percentual) }}</b><span>Conversão</span></div>
          </div>
          <div class="tabelas">
            <ng-container *ngIf="resumo.vendaCartao!.porOperador.length">
              <h3 class="subtitulo">Por operador</h3>
              <table class="tabela fixa" data-teste="vc-operadores">
                <thead><tr><th>Operador</th><th>Abordagens</th><th>Recusas</th><th>Em andamento</th><th>Contratadas</th><th>Conversão</th></tr></thead>
                <tbody><tr *ngFor="let o of resumo.vendaCartao!.porOperador" class="clicavel" (click)="abrirVendaCartaoOperador('operador:' + o.chave)">
                  <td>{{ o.chave }}</td><td>{{ o.abordagens }}</td><td>{{ o.recusas }}</td><td>{{ o.emAndamento }}</td><td>{{ o.contratadas }}</td><td>{{ pctPronto(o.percentual) }}</td>
                </tr></tbody>
              </table>
            </ng-container>
            <ng-container *ngIf="resumo.vendaCartao!.porUnidade.length > 1">
              <h3 class="subtitulo">Por unidade</h3>
              <table class="tabela fixa" data-teste="vc-unidades">
                <thead><tr><th>Unidade</th><th>Abordagens</th><th>Recusas</th><th>Em andamento</th><th>Contratadas</th><th>Conversão</th></tr></thead>
                <tbody><tr *ngFor="let u of resumo.vendaCartao!.porUnidade">
                  <td>{{ nomeUnidade(+u.chave) }}</td><td>{{ u.abordagens }}</td><td>{{ u.recusas }}</td><td>{{ u.emAndamento }}</td><td>{{ u.contratadas }}</td><td>{{ pctPronto(u.percentual) }}</td>
                </tr></tbody>
              </table>
            </ng-container>
            <ng-container *ngIf="resumo.vendaCartao!.porPlano.length">
              <h3 class="subtitulo">Por plano</h3>
              <table class="tabela fixa" data-teste="vc-planos">
                <thead><tr><th>Plano</th><th>Contratadas</th></tr></thead>
                <tbody><tr *ngFor="let p of resumo.vendaCartao!.porPlano"><td>{{ p.rotulo }}</td><td>{{ p.total }}</td></tr></tbody>
              </table>
            </ng-container>
          </div>
          <p class="nota" data-teste="adesoes-upsells">Adesões {{ resumo.vendaCartao!.adesoes }} · Upsells {{ resumo.vendaCartao!.upsells }}</p>
        </div>
      </section>

      <!-- 5. Especialidade + médico -->
      <div class="par-listas">
        <ng-container *ngTemplateOutlet="particulares; context: { $implicit: 'especialidade', titulo: 'Particulares por especialidade', sub: 'Parte dos atendimentos que foi particular', ancora: 's-espec' }"></ng-container>
        <ng-container *ngTemplateOutlet="particulares; context: { $implicit: 'medico', titulo: 'Particulares por médico', sub: 'Parte dos atendimentos de cada médico que foi particular', ancora: 's-medico' }"></ng-container>
      </div>
    </div>
  </ng-container>
</main>

<div *ngIf="lista" class="fundo-modal">
  <div class="lista-modal" role="dialog" aria-modal="true" [attr.aria-label]="lista.titulo" (click)="$event.stopPropagation()">
    <div class="lista-cabeca">
      <h3>{{ lista.titulo }} <span class="nota">({{ lista.total }})</span></h3>
      <button type="button" class="btn-borda" (click)="fecharLista()">Fechar</button>
    </div>
    <p *ngIf="lista.erro" class="erro-texto">{{ lista.erro }}</p>
    <p *ngIf="lista.carregando" class="nota">Carregando...</p>
    <div class="lista-rolagem">
      <table *ngIf="!lista.carregando && lista.itens.length" class="tabela">
        <thead><tr><th>Data</th><th>Paciente</th><th>CPF</th><th>Operador</th><th>Médico / especialidade</th><th>Plano</th><th>Situação</th></tr></thead>
        <tbody><tr *ngFor="let p of lista.itens">
          <td>{{ p.data | date:'dd/MM HH:mm' }}</td><td>{{ p.nome }}</td><td>{{ p.cpf }}</td><td>{{ p.operador }}</td>
          <td>{{ p.medico || p.especialidade }}</td><td>{{ p.plano }}</td><td>{{ p.situacao }}</td>
        </tr></tbody>
      </table>
    </div>
    <p *ngIf="!lista.carregando && !lista.erro && !lista.itens.length" class="nota">Ninguém nesta lista.</p>
    <div *ngIf="paginas > 1" class="paginacao">
      <button type="button" class="btn-borda" [disabled]="lista.pagina <= 1 || lista.carregando" (click)="abrirLista(lista.bloco, lista.chave, lista.titulo, lista.pagina - 1)">Anterior</button>
      <span>Página {{ lista.pagina }} de {{ paginas }}</span>
      <button type="button" class="btn-borda" [disabled]="lista.pagina >= paginas || lista.carregando" (click)="abrirLista(lista.bloco, lista.chave, lista.titulo, lista.pagina + 1)">Próxima</button>
    </div>
  </div>
</div>
